import { Pipe, PipeTransform } from '@angular/core';

import { IdentifierUtils } from '../../core';
import { OtherArticleIdentifierDto } from '@scip/api';

@Pipe({
  name: 'otherArticleIdentifierLabel'
})
export class OtherArticleIdentifierLabelPipe implements PipeTransform {
  transform(otherArticleIdentifier: OtherArticleIdentifierDto): string {
    let otherArticleIdentifierLabelTranslationKey = '';
    if (otherArticleIdentifier?.pickListData?.identifier) {
      otherArticleIdentifierLabelTranslationKey = IdentifierUtils.abbreviateOtherArticleIdentifier(otherArticleIdentifier.pickListData.identifier);
    }
    return otherArticleIdentifierLabelTranslationKey;
  }
}
